module.exports = __webpack_public_path__ + "static/media/share.af2011ae.svg";